// extracted by mini-css-extract-plugin
export default {"DayScaleLayout":"DayScaleLayout_DayScaleLayout__kihXb"};